import {UPLOAD_DATA_SERVICES} from './constants';

export function UploadDataFleetAction(payload: any) {
  return {
    type: UPLOAD_DATA_SERVICES,
    payload,
  };
}
